import React, { useEffect, useRef } from 'react';

interface MenuItem {
  label: string;
  icon: string;
  onClick: () => void;
  dividerAfter?: boolean;
}

interface ContextMenuProps {
  x: number;
  y: number;
  items: MenuItem[];
  onClose: () => void;
}

export default function ContextMenu({ x, y, items, onClose }: ContextMenuProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  // Adjust position to stay within viewport
  const adjustedX = Math.min(x, window.innerWidth - 220);
  const adjustedY = Math.min(y, window.innerHeight - (items.length * 42 + 20));

  return (
    <div className="context-menu" ref={ref} style={{ left: adjustedX, top: adjustedY }}>
      {items.map((item, i) => (
        <React.Fragment key={i}>
          <button className="context-menu-item" onClick={() => { item.onClick(); onClose(); }}>
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </button>
          {item.dividerAfter && <div className="context-menu-divider" />}
        </React.Fragment>
      ))}
    </div>
  );
}
